import React from 'react'
import { connect } from 'react-redux'
import { Alert, Button, Col, DatePicker, Divider, Form, Input, message, Select, Spin, Typography, Upload } from 'antd'
import { UploadOutlined } from '@ant-design/icons'

import '../../asset/less/NewPieces.css'
import { ExcelRenderer } from 'react-excel-renderer'
import { getAllArtistNames } from '../../api/artistNames'
import { getAllArtworkExhibitions, postArtworkExhibition, putArtworkExhibition } from '../../api/artworkExhibition'
import HttpError from '../../component/base/HttpError'
import FormButton from '../../component/base/FormButton'
import ApplyFormErrorMessage from '../../component/apply/ApplyFormErrorMessage'
import Checkbox from 'antd/lib/checkbox/Checkbox'
import { withRouter } from 'react-router'
import moment from 'moment'
import { getArtworkCollectionAdmin } from '../../api/artworkCollections'

const { Option } = Select
const { Title } = Typography

@connect((state) => ({
  userId: state.user.info.id,
  email: state.user.info.email,
  role: state.user.info.role,
  artists: state.artist.artists
}))
class NewExhibitionAdmin extends React.Component {
  constructor(props) {
    super(props)
    this.expoFormRef = React.createRef()
    this.formRef = React.createRef()
    this.state = {
      exibitions: [],
      artistNames: [],
      artworkCollections: [],
      validateError: [],
      loading: false,
      updateBtnEnabled: true
    }
    this.is_new = props.new
    this.targetId = -1
    if (!this.is_new) {
            let getExpoId = () => {
          let id = ''
          const locationArry = this.props.location.pathname.split('/')
        if(locationArry.length > 0) {
          if(locationArry[locationArry.length - 1]) {
            id = parseInt(locationArry[locationArry.length - 1])
          }else{
            id = parseInt(locationArry[locationArry.length - 2])
          }
        }
        return id
      }
      this.targetId = getExpoId()
    }
  }

  componentDidMount() {
    getAllArtworkExhibitions()
      .then((res) => {
        if (!this.is_new) {
          let target = res.data.results.filter((v) => {
            if (v.id === this.targetId) return v
          })
          if (target && target.length > 0) {
            let value = target[0]
            value['date'] = moment(value['date'], 'YYYY-MM-DD')
            value['expire_date'] = moment(value['expire_date'], 'YYYY-MM-DD')
            this.formRef.current.setFieldsValue(value)
          }
        }
        this.setState({
          exibitions: res.data.results
        })
      })
      .catch((error) => {
        HttpError(error)
      })
    getAllArtistNames()
      .then((res) => {
        this.setState({ artistNames: res.data })
      })
      .catch((error) => {
        HttpError(error)
      })
    getArtworkCollectionAdmin(1, 100000, null)
      .then((r) => {
        this.setState({ artworkCollections: r.data.results })
      })
      .catch((error) => {
        HttpError(error)
      })
  }

  onChange = (info) => {
    if (info.file.status === 'done') {
      this.setState({
        updateBtnEnabled: true,
        loading: false
      })
      message.success(`${info.file.name} file uploaded successfully`).then((r) => {})
    } else if (info.file.status === 'error') {
      this.setState({
        updateBtnEnabled: false,
        loading: false
      })
      message.error(`${info.file.name} file upload failed.`).then((r) => {})
    }
  }

  handleUpload = (f, onSuccess) => {
    ExcelRenderer(f, (err, resp) => {
      if (err) {
        message.error(err).then((r) => {})
      } else {
        let rows = resp.rows.filter((v) => {
          return v.length !== 0
        })
        // const titles = rows[0]
        // const columns = titles.map((item, idx) => {
        //   return {
        //     title: item,
        //     dataIndex: idx,
        //     key: idx,
        //     render: (text, record, index) => (
        //       <span
        //         style={{
        //           display: 'block',
        //           overflow: 'hidden',
        //           whiteSpace: 'nowrap',
        //           textOverflow: 'ellipsis'
        //         }}
        //       >
        //         {text}
        //       </span>
        //     )
        //   }
        // })
        rows.shift()
        // const data = rows.map((item, idx) => {
        //   const obj = {}
        //   for (let i = 0; i < item.length; i++) {
        //     if (item[i]) obj[i] = String(item[i]).trim()
        //   }
        //   return obj
        // })
        let artworkIds = []
        let artistIds = []
        let artistNameMap = {}
        rows.map((v) => {
          if (v.length === 0) return
          const i = 0

          let artistName = v[i]
          artistNameMap[artistName] = artistName
          let skuNum = v[i + 1]
          skuNum = parseInt(skuNum)
          if (skuNum > 0) artworkIds.push(skuNum)
        })
        artistNameMap = Object.keys(artistNameMap).map((v) => {
          return v
        })

        this.state.artistNames.map((v) => {
          if (artistNameMap.indexOf(v.name) > -1) {
            artistIds.push(v.artist_id)
          }
        })

        if (artworkIds.length !== artistNameMap.length) {
          message.warning('Some artists name cannot be find, ' + 'try type the artist id directly').then((r) => {})
        }

        this.formRef.current.setFieldsValue({
          artist_ids: artistIds.join(','),
          artwork_ids: artworkIds.join(',')
        })
      }
      onSuccess()
    })
  }

  handleCollectionSelect = (values, option) => {
    if (values) {
      // let oldArtistIds = this.formRef.current.getFieldValue('artist_ids')
      // let oldArtworkIds = this.formRef.current.getFieldValue('artwork_ids')
      let artistIds = []
      let artworkIds = []

      try {
        values.forEach((val) => {
          const artistId = val.split('-')[0]
          const collectionId = val.split('-')[1]
          const ret = this.state.artworkCollections.filter((item) => {
            return item.id.toString() === collectionId.toString()
          })
          artistIds.push(artistId)
          artworkIds = artworkIds.concat(ret[0].artworks)
        })
      } catch (e) {
        message.error('Error in select collection: ' + e).then(() => {})
      }

      this.formRef.current.setFieldsValue({
        artist_ids: artistIds.join(','),
        artwork_ids: artworkIds.join(',')
      })
    }
  }

  onFinish = (params) => {
    const { date, expire_date } = params
    if (date) {
      params['date'] = date.format('YYYY-MM-DD')
    }
    if (expire_date) {
      params['expire_date'] = expire_date.format('YYYY-MM-DD')
    }
    this.setState({
      loading: true
    })
    if (this.is_new) {
      postArtworkExhibition(params)
        .then((v) => {
          message.success('Create Successfully').then((r) => {})
          window.location.reload()
        })
        .catch((e) => {
          HttpError(e)
        })
        .finally(() => {
          this.setState({
            loading: false
          })
        })
    } else {
      putArtworkExhibition(this.targetId, params)
        .then((v) => {
          message.success('Update Successfully').then((r) => {})
          window.location.reload()
        })
        .catch((e) => {
          HttpError(e)
        })
        .finally(() => {
          this.setState({
            loading: false
          })
        })
    }
  }

  onFinishFailed = ({ values, errorFields, outOfDate }) => {
    this.setState({ validateError: errorFields })
    window.scrollTo(0, 0)
    window.scrollTop = 0
  }

  customRequest = (options) => {
    const { onSuccess, file } = options
    this.setState({
      loading: true
    })
    this.handleUpload(file, onSuccess)
  }

  render() {
    let getCollectionLayout = () => {
      const layout = []
      this.state.artworkCollections.forEach((c, index) => {
        layout.push(
          <Option key={index} value={c.artist + '-' + c.id}>
            {'artist:' + c.artist + ' - #' + c.id + ' ' + c.title}
          </Option>
        )
      })
      return layout
    }

    return (
      <Spin size='large' spinning={this.state.loading}>
        <Title>{this.is_new ? 'New' : 'Update'} Exhibition</Title>
        <Divider />
        <ApplyFormErrorMessage error={this.state.validateError} />
        <Form
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 14, offset: 1 }}
          colon={false}
          ref={this.formRef}
          onFinish={this.onFinish}
          onFinishFailed={this.onFinishFailed}
        >
          <Form.Item
            name='title'
            label='Title'
            rules={[
              {
                required: false,
                type: 'string',
                max: 100,
                min: 1
              }
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name='date'
            label='Date'
            rules={[
              {
                type: 'date'
              }
            ]}
          >
            <DatePicker format={'YYYY-MM-DD'} />
          </Form.Item>
          <Form.Item
            name='expire_date'
            label='Expire Date'
            rules={[
              {
                type: 'date'
              }
            ]}
          >
            <DatePicker format={'YYYY-MM-DD'} />
          </Form.Item>
          <Form.Item
            name='thumbnail'
            label='Thumbnail Url'
            rules={[
              {
                required: false,
                type: 'string',
                max: 1024,
                min: 1
              }
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name='location'
            label='Location'
            rules={[
              {
                required: false,
                type: 'string',
                max: 100,
                min: 1
              }
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name='desc'
            label='Description'
            rules={[
              {
                required: false,
                type: 'string',
                max: 1024,
                min: 1
              }
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item name='is_visible' label='Is the exhibition active?'>
            <Checkbox defaultChecked />
          </Form.Item>
          <Alert
            style={{ margin: 24 }}
            message='Notes'
            description='Import artist ids and artwork ids directly from the exhibition excel.'
            type='info'
            showIcon
          />
          <Form.Item
            name='artist_ids'
            label={
              <span>
                Artist ids <br />
                (separated by commas)
              </span>
            }
            rules={[
              {
                required: false,
                type: 'string',
                max: 100000,
                min: 1
              }
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name='artwork_ids'
            label={
              <p>
                Artwork ids <br />
                (separated by commas)
              </p>
            }
            rules={[
              {
                required: false,
                type: 'string',
                max: 100000,
                min: 1
              }
            ]}
          >
            <Input />
          </Form.Item>

          <Col offset={2} span={22}>
            <Divider orientation='left'>Exhibition Importing from collections</Divider>
            <Form.Item label='Collection'>
              <Select mode='multiple' placeholder='Please select' onChange={this.handleCollectionSelect}>
                {getCollectionLayout()}
              </Select>
            </Form.Item>
          </Col>

          <Col offset={2} span={22}>
            <Divider orientation='left'>Exhibition Excel Upload Panel</Divider>
            <Upload maxCount={1} name='fileexcel' customRequest={this.customRequest} onChange={this.onChange}>
              <Button icon={<UploadOutlined />}>Click to upload the excel sheet</Button>
            </Upload>
          </Col>
          <FormButton saveBtnTitle={this.props.new === true ? 'Create exhibition' : 'Update exhibition'} />
        </Form>
      </Spin>
    )
  }
}

export default withRouter(NewExhibitionAdmin)
